import React from 'react';
import DataGrid from '../DataGrid';
import getShipmentsGridConfig from './GridConfig';

const GRID_HEADER_CONFIG = {
  showFullscreen: true,
  showShowHideColumns: true,
  showExportCsv: true,
  showSearchBox: true
};

interface ShipmentsGridProps {
  data: any[];
  onRowDoubleClicked: (event: any) => void;
  onToggleGridMaximize: (isMaximized: boolean) => void;
  isVisible: boolean;
  isMaximized: boolean;
  gridStatus: string | null;
}

const ShipmentsGrid: React.FC<ShipmentsGridProps> = ({
  data,
  onRowDoubleClicked,
  onToggleGridMaximize,
  isVisible,
  isMaximized,
  gridStatus
}) => (
  <DataGrid
    title="Shipments"
    exportFileName="shipment_movement_shipments"
    data={data}
    gridConfig={getShipmentsGridConfig}
    onRowDoubleClicked={onRowDoubleClicked}
    onToggleGridMaximize={onToggleGridMaximize}
    isVisible={isVisible}
    isMaximized={isMaximized}
    gridStatus={gridStatus}
    statusLabel="Shipments"
    gridHeaderConfig={GRID_HEADER_CONFIG}
  />
);

export default ShipmentsGrid;
